
import { Card, CardContent } from "@/components/ui/card";
import { getStorageUrl } from "@/utils/storageUtils";

interface PartnerLogoProps {
  name: string;
  logo: string;
  description: string;
  website?: string;
}

const PartnerLogo = ({ name, logo, description, website }: PartnerLogoProps) => {
  // Convert logo path to full URL if it's a storage path
  const logoUrl = logo?.startsWith('/') || logo?.startsWith('partner-logos/') 
    ? getStorageUrl('partner-logos', logo) 
    : logo;

  const content = (
    <Card className="group hover:shadow-xl transition-all duration-300 hover:scale-105 bg-white/80 backdrop-blur-sm border-2 border-sky-blue/20">
      <CardContent className="p-6 text-center">
        <div className="mb-4 flex justify-center">
          <img 
            src={logoUrl || "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=200&h=100&fit=crop"} 
            alt={`${name} logo`}
            className="h-16 w-auto object-contain group-hover:scale-110 transition-transform duration-300"
            onError={(e) => {
              // Fallback to placeholder image if logo fails to load
              e.currentTarget.src = "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=200&h=100&fit=crop";
            }}
          />
        </div>
        <h3 className="text-lg font-bold text-teedee-blue mb-2">{name}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </CardContent>
    </Card>
  );

  if (website) {
    return (
      <a 
        href={website} 
        target="_blank" 
        rel="noopener noreferrer"
        className="block"
      >
        {content}
      </a>
    );
  }

  return content;
};

export default PartnerLogo;
